import { useEffect, useState } from "react";
import { getUsers } from "../services/userService";

interface IuseFetchUsers {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const useFetchUsers = ({ setIsLoading }: IuseFetchUsers) => {
  const [usersData, setUsersData] = useState<any[]>([]);
  
  useEffect(() => {
    setIsLoading(true);
    const getUsersData = async () => {
      try {
        const res = await getUsers();
        setUsersData(res);
      } catch (err) {
        setUsersData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getUsersData();
  }, [setIsLoading]);

  return [usersData];
};

export default useFetchUsers;
